<div class="skeleton-session" [class.collapsed]="collapsed()">
    <span class="sk avatar"></span>

    @if (!collapsed()) {
        <div class="lines">
            <span class="sk line-title"></span>
            <span class="sk line-meta"></span>
        </div>
    }
</div>
